import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import VisusalFilterState from "../Data/ADIVisualFilterState";
import { VisualFilterCarousal } from "@NA/Services/GetVisualCarousal";
import { RetunOrderSelectModel } from "@NA/Services/ADIReturnSelectService";
import ADIRMAConfirmReturnsState from "../Data/ADIRMAConfirmReturnsState";

const initialState: ADIRMAConfirmReturnsState = {
    isLoading: false,
    isSuccess: true,
    rmaConfirmReturnState: "",
};

const reducer = {
    "Custom/returnProducts": (draft: Draft<ADIRMAConfirmReturnsState>, action: { result: any }) => {
        draft.isLoading = true;
        draft.isSuccess = false;
    },
    "Custom/DispatchCompleteReturnProducts": (draft: Draft<ADIRMAConfirmReturnsState>, action: { result: any }) => {
        let isSuccessFlag = false;
        if (action.result.returnCode == "00" && action.result.returnId.length) {
            // Commented below code as per P21 Change
            // var urls = [];
            // action.result.products.forEach((prd: any) => {
            //     if (prd.upsShippingLabelUrl) urls.push(prd.upsShippingLabelUrl);
            // });
            // if (urls.length == 0) {
            //     isSuccessFlag = false;
            // } else {
                isSuccessFlag = true;
            // }
        } else {
            isSuccessFlag = false;
        }
        draft.isLoading = false;
        draft.isSuccess = isSuccessFlag;
        draft.rmaConfirmReturnState = { ...action.result, isSuccessFlag };
    },
    "Custom/ResetADIRMAConfirmReturns": (
        draft: Draft<ADIRMAConfirmReturnsState>
    ) => {
        draft.isLoading = initialState.isLoading;
        draft.isSuccess = initialState.isSuccess;
        draft.rmaConfirmReturnState = initialState.rmaConfirmReturnState;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
